import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';
import { receivePickUpDate } from '../../../store/actions/pickupDateAction';
import { updateWholeTruckCart } from '../../../store/actions/truckCartAction';

import cartRemote from '../../../api/cartRemote';

import PickUpDate from '../../pickUpDate/PickUpDate';
import GhaInfoContainer from '../../forwarderImport/ghaInfo/GhaInfoContainer';

import TruckCart from '../../../models/TruckCart';
import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';

import Moment from 'moment';
import MomentUtils from "@date-io/moment";
import { Moment as MomentType } from 'moment';

interface TruckCartHeaderProps {
  truckCart: TruckCart;
  receiveError: (error: ResponseError) => void;
  receivePickUpDate: (pickupDate: MomentType) => void;
  updateWholeTruckCart: (cart: TruckCart) => void;
};

interface TruckCartHeaderState {
  pickUpDate: MomentType;
};

class TruckCartHeaderContainer extends Component<TruckCartHeaderProps, TruckCartHeaderState>  {

  state = {
    pickUpDate: new MomentUtils().date()
  }

  componentDidUpdate(prevProps: TruckCartHeaderProps) {

    const newProps: TruckCartHeaderProps = this.props;

    if (prevProps.truckCart !== newProps.truckCart) {

      const pickupDateInDateFormat: Date = Moment(this.props.truckCart.pickup_date, "YYYYMMDD").toDate();
      const dateToMoment: MomentType = new MomentUtils().date(pickupDateInDateFormat);

      this.setState({ pickUpDate: dateToMoment });
    };
  };

  handleChange = (pickUpDate: MomentType): void => {
    
    this.setState({ pickUpDate });
    this.handleUpdate(pickUpDate);
  };

  handleUpdate = (pickUpDate: MomentType): void => {

    const puckUpDateFormated: string = Moment(pickUpDate).format('YYYYMMDD');

    cartRemote.changeTruckCartPickupDate(puckUpDateFormated).then((resp: ApiResponse<TruckCart>) => {

      const cart: TruckCart | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (cart) {

        this.props.receivePickUpDate(pickUpDate);
        this.props.updateWholeTruckCart(cart);
        this.setState({ pickUpDate });
      }
    
      if (error) {
        this.props.receiveError(error);
      }
    });
  };

  render() {

    let ghaId: number = -1;
    const truckCartItems: number = this.props.truckCart.cart.length;

    if (truckCartItems > 0 && this.props.truckCart.cart[0].id_gha) {
      ghaId = this.props.truckCart.cart[0].id_gha;
    };

    return (
      <Fragment>
        { truckCartItems > 0 &&
          <PickUpDate titleText={ 'Schedule Drop Off Date:' } pickUpDate={ this.state.pickUpDate } handleChange={ this.handleChange } /> 
        }
        <GhaInfoContainer ghaId={ ghaId } type={ 'export' }/>
      </Fragment>
    )
  };
};

const mapStateToProps = (state: any) => {
  return {
    truckCart: state.truckCart
  };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
      receiveError: (error: ResponseError) => dispatch(receiveError(error)),
      receivePickUpDate: (pickUpDate: MomentType) => dispatch(receivePickUpDate(pickUpDate)),
      updateWholeTruckCart: (cart: TruckCart) => dispatch(updateWholeTruckCart(cart))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TruckCartHeaderContainer);
